import React, { useContext, memo, useEffect, useState } from "react";
import {
  GoogleMap
} from "@react-google-maps/api";
import { WebMapContext } from "../WebMapGoogleMap";

const GoogleMapView = ({
  children,
  onMapIdle,
  mapTypeId,
  mapTool,
  mapView,
  handleOnLoad,
  onChangeMapType,
  handleMapClick,
  initSetting,
  handleBoundsChange
}) => {
  const {
    mapPlacement
  } = useContext(WebMapContext);
  const [initZoom, setInitZoom] = useState();
  const [initCenter, setInitCenter] = useState();

  useEffect(() => {
    setInitZoom(initSetting.zoom);
    setInitCenter(initSetting.center);
  }, []);

  // map type control custom styles
  useEffect(() => {
    const mtcStyle = document.createElement('style');
    mtcStyle.innerHTML = `
      .gm-style-mtc > ul {
        top: ${mapView !== null ? '-100% !important' : '22px'};
      }
    `;
    document.head.appendChild(mtcStyle);
    return () => {
      const isMTCStyle = document.head.contains(mtcStyle);
      if (isMTCStyle) document.head.removeChild(mtcStyle);
    };
  }, [mapView]);

  return (
    <GoogleMap
      onIdle={onMapIdle}
      options={{
        fullscreenControl: true,
        mapTypeControl: true,
        mapTypeId: mapTypeId || "terrain",
        gestureHandling: "greedy",
        clickableIcons: false,
        draggableCursor: mapTool ? "crosshair" : "",
        controlSize: 22,
        mapTypeControlOptions: {
          position: mapView === null ? 3 : mapPlacement === 'right' ? window.google.maps.ControlPosition.TOP_LEFT : window.google.maps.ControlPosition.TOP_RIGHT,
        },
        fullscreenControlOptions: {
          position: mapPlacement === 'right' ? window.google.maps.ControlPosition.RIGHT_BOTTOM : 6,
        },
        zoomControlOptions: {
          position: mapPlacement === 'right' ? window.google.maps.ControlPosition.RIGHT_BOTTOM : 6,
        },
        streetViewControlOptions: {
          position: mapPlacement === 'right' ? window.google.maps.ControlPosition.RIGHT_BOTTOM : 6,
        }
      }}
      id="circle-example"
      mapContainerStyle={{
        height: "88vh",
        width: "100%",
      }}
      zoom={initZoom}
      center={initCenter}
      onLoad={handleOnLoad}
      onMapTypeIdChanged={onChangeMapType}
      onBoundsChanged={handleBoundsChange}
      {...(mapTool && { onClick: handleMapClick })}
    >
      {children}
    </GoogleMap>
  )
};

export default memo(GoogleMapView);